export default __webpack_public_path__ + "static/media/flag-australia.3550d2d8.svg";